import {
  Directive,
  Input,
  OnDestroy,
  OnInit,
  TemplateRef,
  ViewContainerRef,
  inject,
} from '@angular/core';
import { Subscription } from 'rxjs';
import { AuthService } from '../../core/services/auth.service';
import { Permissions } from '../../core/enums';

@Directive({
  selector: '[appHasPermission]',
  standalone: true,
})
export class HasPermissionDirective implements OnInit, OnDestroy {
  @Input() appHasPermission!: Permissions | string | Permissions[] | string[];

  @Input() appHasPermissionInverse = false;

  private readonly templateRef = inject(TemplateRef<unknown>);
  private readonly vcr = inject(ViewContainerRef);
  private readonly authService = inject(AuthService);

  private subscription?: Subscription;
  private viewCreated = false;

  ngOnInit(): void {
    this.subscription = this.authService
      .getPermissions()
      .subscribe(userPermissions => {
        const requiredPermissions = Array.isArray(this.appHasPermission)
          ? this.appHasPermission
          : [this.appHasPermission];

        let hasAccess = requiredPermissions.some(permission =>
          userPermissions.includes(permission)
        );

        if (this.appHasPermissionInverse) {
          hasAccess = !hasAccess;
        }

        if (hasAccess && !this.viewCreated) {
          this.vcr.createEmbeddedView(this.templateRef);
          this.viewCreated = true;
        } else if (!hasAccess && this.viewCreated) {
          this.vcr.clear();
          this.viewCreated = false;
        }
      });
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }
}
